/* Black Friday 2026 — product page behaviour (snippets/kbf-pdp.liquid).
   Built from the client's prototypes "BF26 live 03.pdf" (desktop) and "BF26 live 04.pdf" (mobile).
   1. Offer selector: "20%" sets the quantity to 1, "2+1" sets it to 3; the radios follow manual quantity changes.
   2. Add-to-cart label: from quantity 2 up it reads "Adaugă 3 în coș · 312 lei" (quantity + BF total of the selection).
   3. Gift ladder: the progress bar follows the cart total (after product discounts, Kite gift lines excluded) plus the
      current selection on the page. Line: "Mai ai X lei până la …" or "Cu această selecție primești …".
   4. Spotlight under the price (4 Nov, part "spot"): the gift tile repeats the gift line and shows the cart's progress
      to the top tier; a click scrolls to the gift ladder (inside the scrolling info column on desktop) and makes it glow.
   Loaded once per page; uses event delegation, so it survives Focal's product re-render on variant change. */
(function () {
  if (window.KBF_PDP) return;
  window.KBF_PDP = true;

  /* ---------- helpers ---------- */
  function money(cents, locale, currency) {
    if (currency && currency !== 'RON') {
      try { return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100); } catch (e) { return (cents / 100).toFixed(2); }
    }
    var ts = locale === 'en' ? ',' : (locale === 'fr' ? ' ' : '.');
    var ds = locale === 'en' ? '.' : ',';
    var whole = Math.floor(cents / 100), dec = cents % 100;
    var str = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ts);
    if (dec > 0) str += ds + (dec < 10 ? '0' : '') + dec;
    return str + ' lei';
  }

  function offersOpen() {
    var s = document.documentElement.getAttribute('data-kbf');
    return s === 'early-in' || s === 'live';
  }

  function mainForm() {
    var offer = document.querySelector('.kbf-offer');
    return offer ? offer.closest('.product-form') : null;
  }

  /* BF total of what is on the page: with "2+1" every full set of 3 costs 2 × full price (the cheapest is free),
     the leftover and the "20%" option use the discounted price. */
  function selection() {
    var offer = document.querySelector('.kbf-offer');
    var form = mainForm();
    if (!offer || !form) return null;
    var input = form.querySelector('input[name="quantity"]');
    var qty = input ? parseInt(input.value, 10) || 1 : 1;
    var full = parseInt(offer.getAttribute('data-kbf-full'), 10) || 0;
    var bf = parseInt(offer.getAttribute('data-kbf-bf'), 10) || 0;
    var setChosen = offer.getAttribute('data-kbf-set') === '1' && !!offer.querySelector('[data-kbf-offer-radio][value="3"]:checked');
    var total = setChosen ? Math.floor(qty / 3) * 2 * full + (qty % 3) * bf : qty * bf;
    return { qty: qty, total: total, form: form, offer: offer, locale: offer.getAttribute('data-kbf-locale') || 'ro', currency: offer.getAttribute('data-kbf-currency') || 'RON' };
  }

  /* ---------- 1. offer selector ---------- */
  function syncRadios(form, qty) {
    var radios = form.querySelectorAll('[data-kbf-offer-radio]');
    if (!radios.length) return;
    var want = qty >= 3 ? '3' : '1';
    /* Since 3 Nov the 2+1 option is a link to the trio page (no "3" radio): the 20% radio then stays checked */
    var hasWant = Array.prototype.some.call(radios, function (r) { return r.value === want; });
    if (!hasWant) want = '1';
    radios.forEach(function (r) { r.checked = (r.value === want); });
  }

  document.addEventListener('change', function (event) {
    var t = event.target;
    if (!t.matches) return;
    if (t.matches('[data-kbf-offer-radio]')) {
      var form = t.closest('.product-form');
      var input = form && form.querySelector('input[name="quantity"]');
      if (input) {
        var value = t.value === '3' ? 3 : 1;
        if (parseInt(input.value, 10) !== value) {
          input.value = value;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          return; /* the quantity change event re-runs render() */
        }
      }
      render();
    } else if (t.matches('.product-form input[name="quantity"]')) {
      syncRadios(t.closest('.product-form'), parseInt(t.value, 10) || 1);
      render();
    }
  });

  /* ---------- 2. add-to-cart label ---------- */
  function applyButton(sel) {
    var button = sel.form.querySelector('[data-product-add-to-cart-button]');
    if (!button || button.disabled) return;
    if (!button.hasAttribute('data-kbf-original')) button.setAttribute('data-kbf-original', button.getAttribute('data-button-content') || button.textContent.trim());
    var original = button.getAttribute('data-kbf-original');
    var label = original;
    if (offersOpen() && sel.qty >= 2 && sel.total > 0) {
      label = (sel.offer.getAttribute('data-kbf-add') || '{n} · {total}').replace('{n}', sel.qty).replace('{total}', money(sel.total, sel.locale, sel.currency));
    }
    if (button.getAttribute('data-button-content') !== label) button.setAttribute('data-button-content', label);
    if (!button.hasAttribute('aria-busy') && button.textContent.trim() !== label) button.textContent = label;
  }

  /* ---------- 3. gift ladder ---------- */
  var cartAmount = null;

  function applyGifts(el, cart, extra) {
    var locale = el.getAttribute('data-kbf-locale') || 'ro';
    var currency = el.getAttribute('data-kbf-currency') || 'RON';
    /* cart + the selection on this page (not in the cart yet): only used for the "with this selection" message.
       The knobs, the fill and "X lei to go" follow the cart alone, like the Kite gift widget in the cart (4 Nov:
       the bar showed a tier as reached while the cart, and Kite, had not reached it). */
    var amount = cart + extra;
    var tiers = [];
    el.querySelectorAll('[data-kbf-tier]').forEach(function (s) {
      var tier = parseInt(s.getAttribute('data-kbf-tier'), 10);
      s.classList.toggle('is-reached', cart >= tier);
      /* previous: s.classList.toggle('is-reached', amount >= tier); */
      if (s.hasAttribute('data-kbf-gift-name')) tiers.push({ tier: tier, name: s.getAttribute('data-kbf-gift-name') });
    });
    tiers.sort(function (a, b) { return a.tier - b.tier; });
    if (!tiers.length) return;

    /* The knobs are inset on the track: 8%, 50%, 92% for three tiers (assets/kbf-pdp.css, .kbf-gifts__steps).
       The fill grows from the left edge to the share of the way to the next knob; past the last tier it is full. */
    var fill = el.querySelector('[data-kbf-gift-fill]');
    if (fill) {
      var inset = 8, segments = tiers.length - 1;
      var knob = function (index) { return segments > 0 ? inset + (100 - 2 * inset) * index / segments : 50; };
      var pct;
      /* previous: the fill used amount (cart + selection) in the four places below */
      if (cart >= tiers[segments].tier) {
        pct = 100;
      } else {
        var i = 0;
        while (i < tiers.length && cart >= tiers[i].tier) i++;
        var lo = i === 0 ? 0 : tiers[i - 1].tier, hi = tiers[i].tier;
        var from = i === 0 ? 0 : knob(i - 1), to = knob(i);
        pct = from + (to - from) * (cart - lo) / (hi - lo);
      }
      fill.style.width = Math.max(0, Math.min(100, pct)) + '%';
    }

    var line = el.querySelector('[data-kbf-gift-line]');
    if (line) {
      var reachedWithSelection = tiers.filter(function (t) { return amount >= t.tier && cart < t.tier; }).pop();
      /* previous: next tier and "X lei to go" measured from amount (cart + selection); now from the cart */
      var next = tiers.filter(function (t) { return cart < t.tier; })[0];
      if (reachedWithSelection) {
        line.textContent = (el.getAttribute('data-kbf-line-reached') || '{gift}').replace('{gift}', reachedWithSelection.name);
        line.hidden = false;
      } else if (next) {
        line.textContent = (el.getAttribute('data-kbf-line') || '{amount} {gift}').replace('{amount}', money(next.tier - cart, locale, currency)).replace('{gift}', next.name);
        line.hidden = false;
      } else {
        line.hidden = true;
      }
    }
  }

  function render() {
    var sel = selection();
    if (sel) applyButton(sel);
    if (cartAmount === null) return;
    var extra = sel ? sel.total : 0;
    document.querySelectorAll('[data-kbf-gifts], .kbf-offer').forEach(function (el) { el.classList.add('is-ready'); });
    document.querySelectorAll('[data-kbf-gifts]').forEach(function (el) { applyGifts(el, cartAmount, extra); });
    applySpot();
  }

  /* ---------- 4. spotlight under the price ---------- */
  function applySpot() {
    var gifts = document.querySelector('[data-kbf-gifts]');
    if (!gifts) return;
    var line = gifts.querySelector('[data-kbf-gift-line]');
    var top = 0;
    gifts.querySelectorAll('.kbf-gifts__step[data-kbf-tier]').forEach(function (s) { top = Math.max(top, parseInt(s.getAttribute('data-kbf-tier'), 10) || 0); });
    document.querySelectorAll('[data-kbf-spot]').forEach(function (spot) {
      var sub = spot.querySelector('[data-kbf-spot-line]');
      if (sub) {
        if (!sub.hasAttribute('data-kbf-default')) sub.setAttribute('data-kbf-default', sub.textContent);
        sub.textContent = line && !line.hidden && line.textContent ? line.textContent : sub.getAttribute('data-kbf-default');
      }
      var fill = spot.querySelector('[data-kbf-spot-fill]');
      if (fill && top > 0) fill.style.width = Math.max(0, Math.min(100, 100 * cartAmount / top)) + '%';
    });
  }

  function scrollParent(el) {
    for (var p = el.parentElement; p && p !== document.body; p = p.parentElement) {
      var o = getComputedStyle(p).overflowY;
      if ((o === 'auto' || o === 'scroll') && p.scrollHeight > p.clientHeight + 4) return p;
    }
    return null;
  }

  document.addEventListener('click', function (event) {
    var tile = event.target.closest && event.target.closest('[data-kbf-spot-gifts]');
    if (!tile) return;
    var gifts = document.querySelector('[data-kbf-gifts]');
    if (!gifts) return;
    var panel = gifts.querySelector('details');
    if (panel) panel.open = true;
    var smooth = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    var box = scrollParent(gifts);
    if (box) {
      /* desktop: the product info column scrolls on its own */
      box.scrollTo({ top: gifts.getBoundingClientRect().top - box.getBoundingClientRect().top + box.scrollTop - 12, behavior: smooth });
    } else {
      /* mobile: the page scrolls; leave room for the sticky header */
      var header = document.querySelector('store-header');
      var offset = (header ? Math.max(0, header.getBoundingClientRect().bottom) : 0) + 16;
      window.scrollTo({ top: gifts.getBoundingClientRect().top + window.pageYOffset - offset, behavior: smooth });
    }
    gifts.classList.remove('is-spotlit');
    void gifts.offsetWidth;
    gifts.classList.add('is-spotlit');
    setTimeout(function () { gifts.classList.remove('is-spotlit'); }, 2000);
  });

  function refresh() {
    if (!document.querySelector('[data-kbf-gifts]')) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var amount = 0;
        (cart.items || []).forEach(function (item) {
          if (item.properties && item.properties._free_product) return; /* Kite gift line */
          amount += item.final_line_price;
        });
        cartAmount = amount;
        render();
      })
      .catch(function () {});
  }

  function onReady(fn) { document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn(); }

  onReady(refresh);
  ['cart:updated', 'cart:refresh'].forEach(function (name) { document.addEventListener(name, function () { setTimeout(refresh, 150); }); });
  ['variant:changed', 'kbf:change'].forEach(function (name) { document.addEventListener(name, function () { setTimeout(render, 100); }); });
  /* Focal replaces the product blocks after a variant change: re-apply once the new DOM is in place */
  var pending = false;
  var observer = new MutationObserver(function () {
    if (pending || !document.querySelector('[data-kbf-gifts]:not(.is-ready), .kbf-offer:not(.is-ready)')) return;
    pending = true;
    window.requestAnimationFrame(function () { pending = false; render(); });
  });
  onReady(function () { observer.observe(document.body, { childList: true, subtree: true }); });
})();
